module.exports = __webpack_public_path__ + "img/authentication.a2bb4170.png";